/* ============================================================
 * GoodBuyz Shop Mega Menu — behaviour
 *
 * Rewritten from snippets/mega-menu.liquid lines 1043-1236.
 *
 * The original was a plugin INTO Globo Mega Menu: it queried
 * `.menu-item.has-mega-menu`, `.gm-target` and `.gm-menu li[data-gmmi="1"]`,
 * and used a MutationObserver because Globo renders the nav client-side.
 * All of that is gone. The trigger is now our own `.gb-shop-trigger`.
 *
 * Removed with it:
 *   - three dead code blocks that were wrapped in Liquid {% comment %} tags
 *     (invalid JS in an asset file, and all Globo-coupled)
 *   - the MutationObserver that waited for Globo's async render
 *   - a `.gm-target.js-no-transition` cleanup pass
 *   - a stray console.log(panel) left in production
 *
 * Dev notes implemented here are marked  // DEV NOTE Dn / Mn
 * ============================================================ */

(function () {
  'use strict';

  var DESKTOP_MIN = 992;

  function init() {
    var root = document.querySelector('[data-gb-root]');
    var mega = document.querySelector('.gb-mega-menu');

    // Delay is a section setting. DEV NOTE D1/D3 — 400ms.
    var delay = 400;
    if (root && root.dataset.gbOpenDelay) {
      var parsed = parseInt(root.dataset.gbOpenDelay, 10);
      if (!isNaN(parsed)) delay = parsed;
    }
    var lockScroll = !root || root.dataset.gbScrollLock !== 'false';

    /* ----------------------------------------------------------
     * Desktop: category panels
     * ---------------------------------------------------------- */
    var categories = document.querySelectorAll('.gb-category');
    var panels = document.querySelectorAll('.gb-panel');
    var switchTimer = null;

    function showPanel(handle) {
      // The menu opens with nothing chosen and the panel region showing a dim
      // through to the page. The first choice fills it and retires the dim; it
      // is deliberately NOT restored on close, so reopening returns a shopper
      // to the category they were last in.
      var megaRoot = document.querySelector('.gb-mega-menu');
      if (megaRoot) megaRoot.classList.remove('is-idle');

      categories.forEach(function (c) {
        c.classList.remove('active');
        c.setAttribute('aria-expanded', 'false');
      });
      panels.forEach(function (p) { p.classList.remove('active'); });

      var cat = document.querySelector('.gb-category[data-tab="' + handle + '"]');
      var panel = document.querySelector('.gb-panel[data-tab="' + handle + '"]');

      if (cat) {
        cat.classList.add('active');
        cat.setAttribute('aria-expanded', 'true');
      }
      if (panel) panel.classList.add('active');
    }

    if (window.innerWidth >= DESKTOP_MIN) {
      categories.forEach(function (category) {
        // Click only.
        //
        // Hover switching was added on 2026-08-25 on top of dev note D3, by
        // request. The design has since moved to click, so D3 stands alone
        // again and the mouseenter / mouseleave pair is gone. The 400ms pause
        // stays: D3 specifies it for the 2nd and 3rd level.
        function scheduleSwitch(handle) {
          if (switchTimer) clearTimeout(switchTimer);
          switchTimer = setTimeout(function () { showPanel(handle); }, delay);
        }

        category.addEventListener('click', function () {
          scheduleSwitch(this.dataset.tab);
        });

        // Keyboard parity — no delay, activation is already deliberate.
        category.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            showPanel(this.dataset.tab);
          }
        });
      });

      // No category is opened here.
      //
      // This used to be DEV NOTE D2, "first category open by default", and it
      // was the SECOND implementation of that note - the Liquid rendered the
      // first category and panel with .active, and this re-applied it at load.
      // Removing only the Liquid half changed nothing on screen, because this
      // line ran on every page load, put .active back and cleared is-idle
      // before anyone saw it.
      //
      // The menu now opens showing the rail alone, per the 2026-08-28 request
      // and kogan.png. showPanel is called only by a click or Enter/Space.
    }

    /* ----------------------------------------------------------
     * Desktop: the Shop trigger
     * ---------------------------------------------------------- */
    var openTimer = null;

    function setOpen(open) {
      if (!root) return;
      root.classList.toggle('is-open', open);
      if (mega) mega.classList.toggle('active', open);

      document.querySelectorAll('.gb-shop-trigger').forEach(function (t) {
        t.setAttribute('aria-expanded', open ? 'true' : 'false');
      });

      // DEV NOTE D6 — the page behind must not scroll while open.
      if (lockScroll) document.body.classList.toggle('gb-menu-open', open);
    }

    function isOpen() {
      return !!root && root.classList.contains('is-open');
    }

    document.querySelectorAll('.gb-shop-trigger').forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();

        if (isOpen()) {
          setOpen(false);          // trigger doubles as an exit
          return;
        }

        // DEV NOTE D1 — 400ms pause between click and open. The opening
        // animation itself is the one already on the site (fadeMega /
        // the .35s transforms in component-gb-shop-menu.css).
        if (openTimer) clearTimeout(openTimer);
        openTimer = setTimeout(function () { setOpen(true); }, delay);
      });
    });

    // DEV NOTE D8 — both X buttons close: the one on the trigger and the
    // one inside the panel.
    document.querySelectorAll('[data-gb-close]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        setOpen(false);
      });
    });

    // DEV NOTE D6 — scrolling must NOT dismiss the menu, and there is
    // deliberately no close-on-outside-click: the notes state the only
    // exits are the two X buttons. Escape is kept for keyboard users.
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen()) setOpen(false);
    });

    /* ----------------------------------------------------------
     * DEV NOTE D10 — desktop scroll region: click-n-drag as well as
     * ordinary mouse scroll (which the CSS overflow already gives us).
     * ---------------------------------------------------------- */
    document.querySelectorAll('[data-gb-scroll-region]').forEach(function (region) {
      var dragging = false, startY = 0, startTop = 0;

      region.addEventListener('mousedown', function (e) {
        if (e.button !== 0) return;
        dragging = true;
        startY = e.pageY;
        startTop = region.scrollTop;
        region.classList.add('is-dragging');
      });

      document.addEventListener('mousemove', function (e) {
        if (!dragging) return;
        region.scrollTop = startTop - (e.pageY - startY);
      });

      document.addEventListener('mouseup', function () {
        if (!dragging) return;
        dragging = false;
        region.classList.remove('is-dragging');
      });
    });

    /* ----------------------------------------------------------
     * Mobile drawer
     *
     * This half was already Globo-free and is kept as-is apart from
     * the removed console.log and the added tap-flash.
     * ---------------------------------------------------------- */
    var level1 = document.querySelector('.gb-mobile-level1');
    var mobileItems = document.querySelectorAll('.gb-mobile-item');
    var mobilePanels = document.querySelectorAll('.gb-mobile-level2');
    var backButtons = document.querySelectorAll('.gb-mobile-back');

    function closePanels() {
      mobilePanels.forEach(function (panel) { panel.classList.remove('active'); });
      if (level1) level1.classList.remove('hide');
    }

    mobileItems.forEach(function (item) {
      item.addEventListener('click', function (e) {
        e.preventDefault();
        var target = this.dataset.target;
        var menu = item.closest('.gb-mobile-menu');
        var panel = menu && menu.querySelector('.gb-mobile-level2[data-panel="' + target + '"]');
        if (panel) panel.classList.add('active');
      });
    });

    backButtons.forEach(function (btn) {
      btn.addEventListener('click', function () { closePanels(); });
    });

    window.addEventListener('resize', function () {
      if (window.innerWidth >= DESKTOP_MIN) closePanels();
    });

    /* ----------------------------------------------------------
     * Popular Brands row — drag, and the slider's auto-advance
     *
     * Both modes were originally CSS-only, and neither worked:
     *
     *   Slider — `scroll-snap-type: x mandatory` only decides where a scroll
     *            comes to REST. It never moves anything, so nothing slid.
     *   Drag   — `overflow-x: auto` gives touch swiping for free, but a mouse
     *            press-and-drag does nothing in an overflow container. At a
     *            mobile width in a desktop browser, drag was simply dead.
     *
     * Same handler shape as the desktop scroll region under dev note D10.
     * ---------------------------------------------------------- */
    document.querySelectorAll('.gb-mobile-brand-track').forEach(function (track) {
      var root = track.closest('[data-gb-drawer]');
      var slider = root && root.classList.contains('gb-drawer--brands-slider');

      /* ---- drag to scroll, in BOTH modes ---- */
      var down = false, startX = 0, startLeft = 0, moved = 0;

      track.addEventListener('pointerdown', function (e) {
        // Ignore secondary buttons; let touch keep its native momentum.
        if (e.button !== 0 || e.pointerType === 'touch') return;
        down = true;
        moved = 0;
        startX = e.clientX;
        startLeft = track.scrollLeft;
        track.classList.add('is-dragging');
      });

      document.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        moved = Math.max(moved, Math.abs(dx));
        track.scrollLeft = startLeft - dx;
      });

      document.addEventListener('pointerup', function () {
        if (!down) return;
        down = false;
        track.classList.remove('is-dragging');
      });

      // A drag that ends over a chip must not follow its link. 4px of slop
      // keeps an ordinary click working.
      track.addEventListener('click', function (e) {
        if (moved > 4) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);

      if (!slider) return;


      /* ---- slider: one chip per step ----
       *
       * This replaces a per-frame drift of 0.3px. That version was hard to see
       * for three separate reasons, any of which could explain "it is not
       * sliding":
       *
       *   - with three chips the row overflows by only ~33px, so the whole
       *     journey lasted under two seconds before reversing — a jiggle
       *   - pausing on mouseenter meant a cursor resting over the row at a
       *     mobile width in a desktop browser held it still indefinitely
       *   - prefers-reduced-motion skipped it entirely, by design
       *
       * A discrete step is unmistakable under all three, and is what was asked
       * for. Movement is one chip width plus one gap, smooth-scrolled, so the
       * step itself is animated by the browser.
       */
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      // Interval in ms between steps.
      var interval = parseInt(root.dataset.gbSlideInterval, 10) || 3000;
      var paused = false;
      var resumeTimer = null;
      var timer = null;

      function chipStep() {
        var chip = track.querySelector('.gb-mobile-brand');
        if (!chip) return 0;

        // Measured rather than read from the settings, so a chip resized by CSS
        // or by a long brand name still steps by exactly one chip.
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return chip.getBoundingClientRect().width + gap;
      }

      function pause() {
        paused = true;
        if (resumeTimer) clearTimeout(resumeTimer);
        // Long enough that a deliberate look is not cut short.
        resumeTimer = setTimeout(function () { paused = false; }, 4000);
      }

      ['pointerdown', 'touchstart', 'wheel'].forEach(function (evt) {
        track.addEventListener(evt, pause, { passive: true });
      });

      /* Hover pause is kept even though it is what most likely made the drift
       * look dead in a desktop browser. On a phone there is no hover, and on a
       * desktop a row that keeps moving under the cursor while someone reads the
       * logos is worse. It is a behaviour that confuses a desktop test, not a
       * bug. */
      track.addEventListener('mouseenter', function () { paused = true; });
      track.addEventListener('mouseleave', function () { paused = false; });

      function advance() {
        if (paused || down) return;

        var max = track.scrollWidth - track.clientWidth;
        if (max <= 1) return;   // nothing to travel; brand images may still be loading

        var step = chipStep();
        if (!step) return;

        // At the end, glide back to the start. A step-by-step reverse would take
        // as long again to return and reads as indecision; smooth-scrolling home
        // is one clear movement.
        var atEnd = track.scrollLeft >= max - 1;
        var target = atEnd ? 0 : Math.min(track.scrollLeft + step, max);

        track.scrollTo({ left: target, behavior: 'smooth' });
      }

      /* Only ticks while the drawer is open. A timer running behind a closed
       * drawer is wasted battery, and scrollTo on a hidden element is a no-op
       * that would silently walk the position out of step. */
      function sync() {
        var open = root.classList.contains('is-open');
        if (open && !timer) {
          timer = setInterval(advance, interval);
        } else if (!open && timer) {
          clearInterval(timer);
          timer = null;
          paused = false;
        }
      }

      sync();
      if (window.MutationObserver) {
        new MutationObserver(sync).observe(root, {
          attributes: true,
          attributeFilter: ['class']
        });
      }
    });

    /* DEV NOTES M4 / M5 — flash ("blink") the hover state on tap, because
     * CSS :hover is unreliable on touch. M5 wants the WHOLE container to
     * flash on the category header, which is why the hook carries a value. */
    document.querySelectorAll('[data-gb-tap]').forEach(function (el) {
      el.addEventListener('touchstart', function () {
        el.classList.add('is-tapped');
      }, { passive: true });

      ['touchend', 'touchcancel'].forEach(function (evt) {
        el.addEventListener(evt, function () {
          setTimeout(function () { el.classList.remove('is-tapped'); }, 150);
        }, { passive: true });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
